import {Injectable} from '@angular/core';
import {DataCoreService} from '@dabnet-kamu/libs/ui';
import {TebFinansmanService} from '../ctl-teb-finansman.service';

@Injectable()
export class Service {

  constructor(private dataCoreService: DataCoreService, private service: TebFinansmanService) {
  }

  getData(control: any) {
    const dataSource = this.dataCoreService.getOData(control.dlistMetadata.baseEntity);
    dataSource.select();
    const filterArr = [];
    if (this.service.period) filterArr.push(['Donem', '=', this.service.period]);
    if (this.service.controlCondition) {
      this.service.controlCondition.forEach((item: any) => {
        filterArr.push([item.conditionColName, item.conditionColSymbol, item.conditionColText]);
      });
    }
    if (filterArr.length > 0) dataSource.filter(filterArr)
    return dataSource;
  }


}
